<script>
    import { onMount, onDestroy } from 'svelte';
    import TutorialRu from "../components/TutorialRu.svelte";
    import TutorialEn from "../components/TutorialEn.svelte";
    import {_} from '../lib/i18n';

    export let params = {};
    export let language = 'ru-RU';
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: $_('tutorial.pageTitle'),
                    pageTitleTag: $_('tutorial.pageTitleTag'),
                    pageMetaDescription: $_('tutorial.pageMetaDescription'),
                    pageLinkCanonical: 'https://instashpion.ru/instashpion/tutorial',
                });
            }
        } catch (err) {
            console.error(err);
        }
    });

    onDestroy(() => {

    });


let showModal = false;
</script>

<div class="canvas__col canvas__col_full-width">
    {#if language === 'ru-RU'}
        <TutorialRu />
    {:else}
        <TutorialEn />
    {/if}
</div>
